import { useParams } from "react-router-dom";
import { PoDetailsEditLocationContainer } from "./container";

export const PoDetailsEditLocationPane = () => {
  const params = useParams();
  const { location } = params;
  return location ? <PoDetailsEditLocationContainer id={location} /> : <></>;
};
